const config = {
  BASE_URL: "https://www.devtestapp.com",
  // BASE_URL: "https://debug.devtestapp.com",
  PLATFORM: "iOS_Novel_Test"
}

export default config;
